<template>
  <img
    :src="logoSrc"
    alt="CocoUni"
    class="brand-logo"
    :class="`brand-logo--${size}`"
  />
</template>

<script setup lang="ts">
import logoSrc from "@/assets/logococo.png";

defineProps({
  size: {
    type: String,
    default: "md",
    validator: (value) => ["sm", "md", "lg"].includes(value),
  },
});
</script>

<style scoped>
.brand-logo {
  display: block;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

.brand-logo--sm {
  height: 112px;
}

.brand-logo--md {
  height: 128px;
}

.brand-logo--lg {
  height: 144px;
}
</style>
